import { PaginatedResponse } from "@/types/Api";

export class ExtractNextPageParam {
  static fromPaginatedResponse(res: PaginatedResponse): number | undefined {
    return res.meta.currentPage < res.meta.totalPages
      ? res.meta.currentPage + 1
      : undefined;
  }
}
